// react core
import React, { useState, useEffect } from 'react';

// components
import AjaxSpinner from 'components/commons/ajax_spinner';
import QuestionSummary from 'components/questions/question_summary';

// api
import {user_api} from 'commons/api';
import {make_range_iterator} from 'commons/utils';

export default function Votes(props)
{
    const [isLoaded, setIsLoaded] = useState(false);
    const [data, set_data] = useState(null);
    const user = props.username;

    useEffect(() =>
    {
        const fetchData = async () =>
        {
            const result = await user_api.get_voted_question_by_user(user);
            if(result.status && result.status === 'ok')
            {
                setIsLoaded(true);
                set_data(result);
            }
        }
        setIsLoaded(false);
        fetchData().catch(console.error);
    }, [user]);


    const details = (item) =>
    {
        return (<></>)
        /*return(
        <>
        {item.question_upvoted === true && <span><i className="fa-regular fa-thumbs-up"></i> upvoted the question</span>}
        {item.question_downvoted === true && <span><i className="fa-regular fa-thumbs-down"></i>  downvoted the question</span>}
        {item.answer_upvotes === 1 && <span><i className="fa-regular fa-thumbs-up"></i> upvoted an answer</span>}
        {item.answer_upvotes > 1 && <span><i className="fa-regular fa-thumbs-up"></i> upvoted {item.answer_upvotes} answers</span>}
        {item.answer_downvotes === 1 && <span><i className="fa-regular fa-thumbs-down"></i> downvoted an answer</span>}
        {item.answer_downvotes > 1 && <span><i className="fa-regular fa-thumbs-down"></i> downvoted {item.answer_downvotes} answers</span>}
        </>)*/
    }
    const ids = make_range_iterator();
    if (!isLoaded || data === null)
    {
        return <AjaxSpinner type='inline' />;
    }
    else return (
        <div className="questions-list-wrapper">
            {
                data.voted.length ?
                data.voted.map(item => (
                    <QuestionSummary key={ids.next().value} item={item.question} extra_details={details(item)}/>
                ))
                : <div>User has not cast any upvotes.</div>
            }

        </div>
    );
};

